module.exports = __webpack_public_path__ + "static/hyperv_38.0dee6710.jpg";